import { render, staticRenderFns } from "./ContentBlock.vue?vue&type=template&id=0424c67e&"
import script from "./ContentBlock.vue?vue&type=script&lang=js&"
export * from "./ContentBlock.vue?vue&type=script&lang=js&"
import style0 from "./ContentBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0424c67e')) {
      api.createRecord('0424c67e', component.options)
    } else {
      api.reload('0424c67e', component.options)
    }
    module.hot.accept("./ContentBlock.vue?vue&type=template&id=0424c67e&", function () {
      api.rerender('0424c67e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/custom/ContentBlock.vue"
export default component.exports